/**
 * PromotionDetailContainer
 * --
 */
import React from 'react';
import PromotionDetailPresenter from './PromotionDetailPresenter';

const PromotionDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <PromotionDetailPresenter />
    </>
  );
};

export default PromotionDetailContainer;
